<template>
  <div>
    <section class="content-header">
      <h1>
        <span>{{ $ml.get('shared.payrollManagement') }}</span>
      </h1>
      <ol class="breadcrumb">
        <li>
          <i class="fa fa-dashboard"></i>
          <span>{{ $ml.get('shared.dashboard') }}</span>
        </li>
        <li>
          <span>{{ $ml.get('shared.payrollManagement') }}</span>
        </li>
      </ol>
    </section>
    <section class="content">
      <div class="row" style="padding-bottom:10px">
        <div class="col-sm-12 col-lg-4" style="padding-bottom:5px;">
          <div class="input-group" style="margin-top:25px">
            <input type="text" :placeholder="$ml.get('employees.searchEmployeeInList')" v-model="searchText"
              class="form-control" autocomplete="false" />
            <span class="input-group-btn">
              <button type="button" class="btn btn-danger " style="width:100%;" data-toggle="modal"
                data-target="#modal-filtre">
                <i class="fa fa-filter"></i> Kişileri Filtrele
              </button>
            </span>
          </div>
        </div>
        <div class="col-sm-4 col-lg-2" style="padding-bottom:5px">
          <div class="input-group" style="width:100%;">
            <label>Başlangıç Tarihi</label>
            <input type="datetime-local" class="form-control" v-model="startDate" />
          </div>
        </div>
        <div class="col-sm-4 col-lg-2" style="padding-bottom:5px">
          <div class="input-group" style="width:100%;">
            <label>Bitiş Tarihi</label>
            <input type="datetime-local" class="form-control" v-model="endDate" />
          </div>
        </div>
        <div class="col-sm-4 col-lg-4">
          <button @click="getData()" class="btn btn-primary pull-right " style="width:100%;margin-top:25px">
            <i class="fa fa-search"></i>
            Görüntüle
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-9">
          <div class="box box-primary">
            <div class="box-header with-border">
              <i class="fa fa-calendar"></i>
              <h3 class="box-title">
                <span>Puantaj Özeti</span>
              </h3>
              <div class="box-tools pull-right">
                <button class="btn btn-success " @click="exportToExcel()">
                  <i class="fa fa-share"></i> Excele Aktar
                </button>
                <!--<select class="form-control">
                  <option value="0" checked>Genel</option>
                  <option value="1">İzinliler</option>
                  <option value="2">Erken Çıkanlar</option>
                  <option value="3">Geç Gelenler</option>
                  <option value="4">Eksik Mesai</option>
                  <option value="5">Fazla Mesai</option>
                </select>-->
              </div>
            </div>
            <div class="box-body">
              <div v-show="payrollDataList.length > 0" class="table-responsive no-padding" :style="windowHeightSize">
                <table id="printExcel" class="table table-hover">
                  <thead>
                    <tr class="dep-baslik">
                      <th></th>
                      <th @click="setOrderEmp(1)" style="cursor:pointer;min-width:75px;">
                        <strong>
                          {{ $ml.get('employees.registrationNumberInfo') }}
                          <i v-show="orderEmpList == 1" class="fa fa-sort-numeric-asc"></i>
                          <i v-show="orderEmpList == 2" class="fa fa-sort-numeric-desc"></i>
                        </strong>
                      </th>
                      <th @click="setOrderEmp(2)" style="cursor:pointer;">
                        <strong>
                          {{ $ml.get('employees.nameSurname') }}
                          <i v-show="orderEmpList == 3" class="fa fa-sort-alpha-asc"></i>
                          <i v-show="orderEmpList == 4" class="fa fa-sort-alpha-desc"></i>
                        </strong>
                      </th>
                      <th>Çalışma Planı</th>
                      <th>Mesai Tarihi</th>
                      <th>İlk Giriş</th>
                      <th>Son Çıkış</th>
                      <th class="text-center">
                        Normal
                        <br />Çalışma
                      </th>
                      <th class="text-center">
                        Eksik
                        <br />Saat
                      </th>
                      <th class="text-center">
                        Hesaplanan
                        <br />F.M.
                      </th>
                      <th class="text-center">
                        Onaylanan
                        <br />F.M.
                      </th>
                      <th>İzin Açıklama</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody :class="employee.employeeId == employee1.employeeId ? 'bg-primary' : ''"
                    v-for="employee1 in filtered" :key="employee1.employeeId">
                    <tr class="text-bold">
                      <td></td>
                      <td>{{ employee1.registrationNumber }}</td>
                      <td>
                        {{ employee1.name }}
                        <span v-show="employee1.title">({{ employee1.title }})</span>
                      </td>
                      <td>{{ employee1.workPlan }}</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td class="text-center">{{ employee1.totalWorkTime }}</td>
                      <td class="text-center">{{ employee1.totalMissingHour }}</td>
                      <td class="text-center">{{ employee1.totalCalculatedOvertime }}</td>
                      <td class="text-center">{{ employee1.totalConfirmedOvertime }}</td>
                      <td></td>
                      <td>
                        <button v-show="!employee1.isOpen" @click="getPayrollDetail(employee1)"
                          class="btn btn-primary btn-sm">
                          <i class="fa fa-search"></i>
                        </button>
                        <button v-show="employee1.isOpen" @click="employee1.isOpen = false"
                          class="btn btn-danger btn-sm">
                          <i class="fa fa-times"></i>
                        </button>
                      </td>
                    </tr>
                    <tr style="background-color:#f4f4f4;"
                      v-show="employee1.payrollDetails.length > 0 && employee1.isOpen"
                      v-for="(detail, index) in employee1.payrollDetails" :key="detail.employeeId + '-' + index">
                      <td style="cursor:pointer;">
                        <input type="checkbox" :checked="detail.check" @click="checkRow(detail)" />
                      </td>
                      <td style="cursor:pointer;" @click="checkRow(detail)">{{ employee1.registrationNumber }}</td>
                      <td style="cursor:pointer;" @click="checkRow(detail)">
                        {{ employee1.name }}
                        <span v-show="employee1.title">({{ employee1.title }})</span>
                      </td>
                      <td style="cursor: pointer;" @click="changeWorkPlan(detail)">{{ detail.workPlan }}</td>
                      <td class="text-center">{{ detail.date }}</td>
                      <td class="text-center text-success"
                        :style="detail.firstEntryModified ? 'text-decoration: underline;font-weight:bold;cursor:pointer;' : 'cursor:pointer;font-weight:bold;'"
                        data-toggle="tooltip"
                        :title="detail.firstEntryModified ? detail.firstEntry + ' (' + detail.firstEntryModifiedUserName + ')' : detail.firstEntry">
                        {{ toDateFormatGet(detail.firstEntry) }}</td>
                      <td class="text-center text-danger"
                        :style="detail.lastExitModified ? 'text-decoration: underline;font-weight:bold;cursor:pointer;' : 'cursor:pointer;font-weight:bold;'"
                        data-toggle="tooltip"
                        :title="detail.lastExitModified ? detail.lastExit + ' (' + detail.lastExitModifiedUserName + ')' : detail.lastExit">
                        {{ toDateFormatGet(detail.lastExit) }}</td>
                      <td class="text-center">{{ detail.totalWorkTime }}</td>
                      <td :class="detail.missingHour != '00:00' ? 'text-center text-danger' : 'text-center'">
                        {{ detail.missingHour }}</td>
                      <td :class="detail.calculatedOverTime != '00:00' ? 'text-center text-primary' : 'text-center'">
                        {{ detail.calculatedOverTime }}</td>
                      <td
                        :class="detail.confirmedOverTime == '00:00' || detail.confirmedOverTime == detail.calculatedOverTime ? 'text-center' : 'text-center text-primary'">
                        {{ detail.confirmedOverTime }}</td>
                      <td class="text-center">{{ detail.holidayDescription }}</td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-show="payrollDataList.length == 0" class="callout callout-info">
                <i class="fa fa-info-circle"></i>
                {{ $ml.get("employees.employeeSearchNotFound") }}
              </div>
            </div>
            <div class="overlay" id="load" :hidden="!isLoadingEmployee">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
          </div>
        </div>
        <div class="col-sm-3">
          <div class="box box-primary">
            <div class="box-header with-border">
              <i class="fa fa-edit"></i>
              <h3 class="box-title">
                <span>İşlemler</span>
              </h3>
              <div class="box-tools pull-right"></div>
            </div>
            <div class="box-body">
              <div v-show="isCheckedRowList.length == 0" class="alert alert-info">
                <i class="fa fa-info-circle"></i> Lütfen bir seçim yapın...
              </div>
              <div v-show="isCheckedRowList.length > 0" class="box-group" id="titles">
                <div class="panel box box-primary">
                  <div class="box-header with-border">
                    <h4 class="box-title">
                      <a data-toggle="collapse" data-parent="#titles" href="#collapseOne" aria-expanded="true" class>
                        <i class="fa fa-briefcase"></i> Çalışma Planı
                      </a>
                    </h4>
                  </div>
                  <div id="collapseOne" class="panel-collapse collapse in" aria-expanded="true" style>
                    <div class="box-body">
                      <ul style="padding-inline-start:10px;">
                        <li style="width:100%;text-align:left;font-size:12px;margin-bottom:10px;"
                          v-for="(al, index) in isCheckedRowList" :key="index">
                          {{ al.registrationNumber }} - {{ al.name }}
                          <span style="padding:6px 5px;font-size:12px;margin-bottom:5px;"
                            class="label pull-right bg-blue">{{ al.date }}</span>
                          <br />
                          <span class="label bg-yellow" style="font-size:12px;margin-top:10px;">{{ al.workPlan }}</span>
                        </li>
                      </ul>
                      <button v-show="isCheckedRowList.length > 0" data-toggle="modal" data-target="#changePayroll"
                        class="btn btn-danger" style="width:100%;">Çalışma Planı Güncelle</button>
                    </div>
                  </div>
                </div>
                <div class="panel box box-danger">
                  <div class="box-header with-border">
                    <h4 class="box-title">
                      <a data-toggle="collapse" data-parent="#titles" href="#collapseTwo" class="collapsed"
                        aria-expanded="false">
                        <i class="fa fa-exchange"></i> Hareket
                      </a>
                    </h4>
                  </div>
                  <div id="collapseTwo" class="panel-collapse collapse" aria-expanded="false" style="height: 0px;">
                    <div class="box-body">
                      <div class="accordion" id="movements">
                        <div v-for="(dateDetail, index) in selectedDateDetailList" :key="index" class="card">
                          <div class="card-header">
                            <h2 class="mb-0" style="margin-top:0px;">
                              <button class="btn btn-secondary" style="width:100%;text-align:left;font-size:12px;"
                                type="button" data-toggle="collapse" :data-target="'#movement' + index"
                                aria-expanded="true" :aria-controls="'movement' + index">
                                {{ dateDetail.registrationNumber }} - {{ dateDetail.employeeName }}
                                <span style="padding:6px 5px;font-size:12px;"
                                  class="label pull-right bg-blue">{{ dateDetail.date }}</span>
                              </button>
                            </h2>
                          </div>
                          <div :id="'movement' + index" class="collapse in" data-parent="#movements">
                            <div class="card-body">
                              <div v-show="isNewInOut">
                                <input v-model="newInOut.date" type="time" class="form-control text-center input-sm" />
                                <div class="btn-group btn-group-toggle text-center" style="margin-top:5px;">
                                  <button
                                    :class="newInOut.inOrOut == 1 ? 'btn btn-success btn-sm' : 'btn btn-secondary btn-sm'"
                                    @click="newInOut.inOrOut = 1">Giriş</button>
                                  <button
                                    :class="newInOut.inOrOut == 2 ? 'btn btn-danger btn-sm' : 'btn btn-secondary btn-sm'"
                                    @click="newInOut.inOrOut = 2">Çıkış</button>
                                </div>
                                <select style="margin-top:5px;font-size:12px;" class="form-control"
                                  @change="changeSelectedReader($event)">
                                  <option v-for="reader in readerList" :key="reader.id"
                                    :selected="reader.id == newInOut.readerId" :value="reader.id">{{ reader.name }}
                                  </option>
                                </select>
                                <div style="margin-top:5px;">
                                  <button
                                    @click="saveMovement(dateDetail.date, dateDetail.employeeId, dateDetail.employeeName, dateDetail.registrationNumber)"
                                    class="btn btn-success btn-sm" style="width:100%;">
                                    <i class="fa fa-check"></i> Kaydet
                                  </button>
                                  <button @click="isNewInOut = false" class="btn btn-secondary btn-sm"
                                    style="width:100%;">
                                    <i class="fa fa-times"></i>İptal
                                  </button>
                                </div>
                              </div>
                              <button v-show="!isNewInOut" @click="clearInOut()" class="btn btn-warning btn-sm"
                                style="width:100%;">
                                <i class="fa fa-plus"></i> Yeni Hareket
                              </button>
                              <table class="table table-hover" style="padding-inline-start:0px;">
                                <tbody>
                                  <tr v-for="movement in dateDetail.movements" :key="movement.id">
                                    <td>
                                      <input v-model="movement.date" type="time"
                                        class="form-control text-center input-sm" />
                                    </td>
                                    <td style="padding-top:14px;">
                                      <span @click="movement.inOrOut == 2 ? movement.inOrOut = 1 : movement.inOrOut = 2"
                                        :class="movement.inOrOut == 2 ? 'label bg-red' : 'label bg-green'"
                                        style="cursor:pointer;font-size:10px;padding:8px 5px;"
                                        v-text="movement.inOrOut == 2 ? 'Çıkış' : 'Giriş'"></span>
                                    </td>
                                    <td>
                                      <button title="Güncelle"
                                        @click="updateMovement(dateDetail.employeeId, dateDetail.employeeName, dateDetail.date, movement, dateDetail.registrationNumber)"
                                        class="btn btn-primary btn-xs">
                                        <i class="fa fa-refresh"></i>
                                      </button>
                                      <button title="Sil"
                                        @click="deleteMovement(dateDetail.employeeId, dateDetail.employeeName, dateDetail.date, movement, dateDetail.registrationNumber)"
                                        class="btn btn-danger btn-xs">
                                        <i class="fa fa-trash"></i>
                                      </button>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="panel box box-success">
                  <div class="box-header with-border">
                    <h4 class="box-title">
                      <a data-toggle="collapse" data-parent="#titles" href="#collapseThree" class="collapsed"
                        aria-expanded="false">
                        <i class="fa fa-calendar-check-o"></i> Fazla Mesai
                      </a>
                    </h4>
                  </div>
                  <div id="collapseThree" class="panel-collapse collapse" aria-expanded="false" style="height: 0px;">
                    <div class="box-body">
                      <div class="accordion" id="overtimes">
                        <div v-for="(dateDetail, index) in selectedDateDetailList" :key="index" class="card">
                          <div class="card-header">
                            <h2 class="mb-0" style="margin-top:0px;">
                              <button class="btn btn-secondary" style="width:100%;text-align:left;font-size:12px;"
                                type="button" data-toggle="collapse" :data-target="'#overtime' + index"
                                aria-expanded="true" :aria-controls="'overtime' + index">
                                {{ dateDetail.registrationNumber }} - {{ dateDetail.employeeName }}
                                <span style="padding:6px 5px;font-size:12px;"
                                  class="label pull-right bg-blue">{{ dateDetail.date }}</span>
                              </button>
                            </h2>
                          </div>
                          <div :id="'overtime' + index" class="collapse in" data-parent="#overtimes">
                            <div class="card-body">
                              <table class="table table-hover" style="padding-inline-start:0px;">
                                <thead>
                                  <tr>
                                    <th class="text-center">Hesaplanan</th>
                                    <th class="text-center">Onaylanan</th>
                                    <th class="text-center"></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td class="text-center">
                                      <label>{{ dateDetail.overtimes.calculated }}</label>
                                    </td>
                                    <td class="text-center">
                                      <label>{{ dateDetail.overtimes.confirmed }}</label>
                                    </td>
                                    <td class="text-center">
                                      <button
                                        :disabled="dateDetail.overtimes.calculated == '00:00' || dateDetail.overtimes.calculated == dateDetail.overtimes.confirmed"
                                        title="Onayla" class="btn btn-primary btn-xs"
                                        @click="confirmOverTime(dateDetail.overtimes.overTimeId, dateDetail.overtimes.confirmed, dateDetail.overtimes.calculated, dateDetail.date, dateDetail.employeeId, dateDetail.employeeName, dateDetail.registrationNumber)">
                                        <i class="fa fa-check"></i>
                                      </button>
                                      <button :disabled="dateDetail.overtimes.confirmed == '00:00'"
                                        @click="deleteOverTime(dateDetail.overtimes.overTimeId, dateDetail.date, dateDetail.employeeId, dateDetail.employeeName, dateDetail.registrationNumber)"
                                        title="Onaylananı Sil" class="btn btn-danger btn-xs">
                                        <i class="fa fa-times"></i>
                                      </button>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="panel box box-success">
                  <div class="box-header with-border">
                    <h4 class="box-title">
                      <a data-toggle="collapse" data-parent="#titles" href="#collapseFour" class="collapsed"
                        aria-expanded="false">
                        <i class="fa fa-clock-o"></i> Puantaj Detayı
                      </a>
                    </h4>
                  </div>
                  <div id="collapseFour" class="panel-collapse collapse" aria-expanded="false" style="height: 0px;">
                    <div class="box-body">
                      <div class="accordion" id="payrolls">
                        <div v-for="(dateDetail, index) in selectedDateDetailList" :key="index" class="card">
                          <div class="card-header">
                            <h2 class="mb-0" style="margin-top:0px;">
                              <button class="btn btn-secondary" style="width:100%;text-align:left;font-size:12px;"
                                type="button" data-toggle="collapse" :data-target="'#payroll' + index"
                                aria-expanded="true" :aria-controls="'payroll' + index">
                                {{ dateDetail.registrationNumber }} - {{ dateDetail.employeeName }}
                                <span style="padding:6px 5px;font-size:12px;"
                                  class="label pull-right bg-blue">{{ dateDetail.date }}</span>
                              </button>
                            </h2>
                          </div>
                          <div :id="'payroll' + index" class="collapse in" data-parent="#payrolls">
                            <div class="card-body">
                              <table class="table table-hover" style="padding-inline-start:0px;">
                                <tbody>
                                  <tr v-for="payroll in dateDetail.payrolls" :key="payroll.id">
                                    <td>
                                      <label>{{ payroll.time }}</label>
                                    </td>
                                    <td>
                                      <label>{{ payroll.payroll }}</label>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL START-->
      <div class="modal modal-primary fade" id="changePayroll">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('employees.updateWorkPlan') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-sm-6" style="color:black; padding:0px 10px;">
                  <div v-show="allowenceList.length > 0" class="table-responsive no-padding"
                    style="max-height:450px; owerflow:auto;background-color:#fff;">
                    <table class="table table-hover">
                      <tbody>
                        <tr v-for="(allowence, index) in allowenceList" :key="index">
                          <td>{{ allowence.name }}</td>
                          <td>
                            <button @click="setChangePayroll(allowence.id, true)" data-dismiss="modal"
                              class="btn btn-primary btn-sm " type="button"
                              style="width:100%;">{{ $ml.get('general.select') }}</button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div v-show="allowenceList.length == 0" class="callout callout-info">
                      <i class="fa fa-info-circle"></i>
                      {{ $ml.get('employees.updateAllowenceNotRecord') }}
                    </div>
                  </div>
                </div>
                <div class="col-sm-6" style="color:black; padding:0px 10px;">
                  <div v-show="workGroupList.length > 0" class="table-responsive no-padding"
                    style="max-height:450px; owerflow:auto;background-color:#fff;">
                    <table class="table table-hover">
                      <tbody>
                        <tr v-for="(workGroup, index) in workGroupList" :key="index">
                          <td>{{ workGroup.name }}</td>
                          <td>
                            <button @click="setChangePayroll(workGroup.id, false)" data-dismiss="modal"
                              class="btn btn-primary btn-sm " type="button"
                              style="width:100%;">{{ $ml.get('general.select') }}</button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div v-show="workGroupList.length == 0" class="callout callout-info">
                      <i class="fa fa-info-circle"></i>
                      {{ $ml.get('employees.updateWorkPlanNotRecord') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{ $ml.get('general.cancel') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!-- /.MODAL START-->
      <div class="modal modal-primary fade" id="modal-filtre">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('filters.filterEmployees') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <span>{{ $ml.get('filters.filterNameSurnameOrCardNo') }}</span>
                    <input v-model="filters.nameOrCardNumber" type="text" class="form-control input-sm"
                      :placeholder="$ml.get('filters.filterNameSurnameOrCardNo')" style="margin-bottom:5px;" />
                  </div>
                  <div class="form-group">
                    <span>{{ $ml.get('filters.filterCitizenshipNumber') }}</span>
                    <input v-model="filters.identityNo" type="text" class="form-control input-sm"
                      :placeholder="$ml.get('filters.filterCitizenshipNumber')" style="margin-bottom:5px;" />
                  </div>
                  <div class="form-group">
                    <span>{{ $ml.get('filters.filterRegistrationOrDeviceNo') }}</span>
                    <input v-model="filters.sicilOrTerminalNo" type="text" class="form-control input-sm"
                      :placeholder="$ml.get('filters.filterRegistrationOrDeviceNo')" style="margin-bottom:5px;" />
                  </div>
                  <div class="form-group">
                    <span>{{ $ml.get('filters.filterTitle') }}</span>
                    <select @change="changeFilterTitles($event)" class="form-control input-sm"
                      style="margin-bottom:5px;">
                      <option :selected="filters.title == ''" value>{{ $ml.get('general.select') }}</option>
                      <option v-for="title in titleList" :key="title.name" :value="title.name"
                        :selected="title.name == filters.title">{{ title.name }}</option>
                    </select>
                  </div>
                  <div class="form-group">
                    <label>{{ $ml.get('filters.filterStatus') }}</label>
                    <div class="input-group">
                      <label v-show="checkedStatusList != ''" class="form-control tdb-box">{{ checkedStatusList }}</label>
                      <label v-show="checkedStatusList == ''"
                        class="form-control">{{ $ml.get('general.notSelected') }}</label>
                      <div class="input-group-btn">
                        <button class="btn btn-default" data-toggle="modal" data-target="#modal-select-status">
                          <i class="fa fa-search"></i>
                        </button>
                        <button v-show="checkedStatusList != ''" class="btn btn-danger" @click="clearFilterStatus()">
                          <i class="fa fa-remove"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <span v-if="modules.customFieldName == ''">{{ $ml.get('filters.filterDocumentNoOrEmail') }}</span>
                    <span v-else>{{ modules.customFieldName + ' / ' + $ml.get('filters.filterDocumentNoOrEmail') }}</span>
                    <input v-model="filters.documentNoOrMail" type="text" class="form-control input-sm"
                      :placeholder="modules.customFieldName != '' ? modules.customFieldName + ' / ' + $ml.get('filters.filterDocumentNoOrEmail') : $ml.get('filters.filterDocumentNoOrEmail')"
                      style="margin-bottom:5px;" />
                  </div>
                  <div class="form-group" v-show="modules.licencePlateRecognition">
                    <span>{{ $ml.get('filters.filterPlateNo') }}</span>
                    <input v-model="filters.plateNo" type="text" class="form-control input-sm"
                      :placeholder="$ml.get('filters.filterPlateNo')" style="margin-bottom:5px;" />
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label>{{ $ml.get('filters.filterDepartments') }}</label>
                    <div class="input-group">
                      <label v-show="checkedDepartmentList != ''"
                        class="form-control tdb-box">{{ checkedDepartmentList }}</label>
                      <label v-show="checkedDepartmentList == ''"
                        class="form-control">{{ $ml.get('general.notSelected') }}</label>
                      <div class="input-group-btn">
                        <button class="btn btn-default" data-toggle="modal" data-target="#modal-select-department">
                          <i class="fa fa-search"></i>
                        </button>
                        <button v-show="checkedDepartmentList != ''" class="btn btn-danger"
                          @click="clearFilterDepartments()">
                          <i class="fa fa-remove"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label>{{ $ml.get('filters.filterAccessGroup') }}</label>
                    <div class="input-group">
                      <label v-show="checkedAccessGroupList != ''"
                        class="form-control tdb-box">{{ checkedAccessGroupList }}</label>
                      <label v-show="checkedAccessGroupList == ''"
                        class="form-control">{{ $ml.get('general.notSelected') }}</label>
                      <div class="input-group-btn">
                        <button class="btn btn-default" data-toggle="modal" data-target="#modal-select-access">
                          <i class="fa fa-search"></i>
                        </button>
                        <button v-show="checkedAccessGroupList != ''" class="btn btn-danger"
                          @click="clearFilterAccessGroup()">
                          <i class="fa fa-remove"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label>{{ $ml.get('filters.filterWorkPlan') }}</label>
                    <div class="input-group">
                      <label v-show="checkedWorkGroupList != ''"
                        class="form-control tdb-box">{{ checkedWorkGroupList }}</label>
                      <label v-show="checkedWorkGroupList == ''"
                        class="form-control">{{ $ml.get('general.notSelected') }}</label>
                      <div class="input-group-btn">
                        <button class="btn btn-default" data-toggle="modal" data-target="#modal-select-workplan">
                          <i class="fa fa-search"></i>
                        </button>
                        <button v-show="checkedWorkGroupList != ''" class="btn btn-danger"
                          @click="clearFilterWorkPlans()">
                          <i class="fa fa-remove"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="form-group" v-show="modules.diningHall">
                    <label>{{ $ml.get('filters.filterFoodGroup') }}</label>
                    <div class="input-group">
                      <label v-show="checkedFoodGroupList != ''"
                        class="form-control tdb-box">{{ checkedFoodGroupList }}</label>
                      <label v-show="checkedFoodGroupList == ''"
                        class="form-control">{{ $ml.get('general.notSelected') }}</label>
                      <div class="input-group-btn">
                        <button class="btn btn-default" data-toggle="modal" data-target="#modal-select-diningHall">
                          <i class="fa fa-search"></i>
                        </button>
                        <button v-show="checkedFoodGroupList != ''" class="btn btn-danger"
                          @click="clearFilterFoodGroups()">
                          <i class="fa fa-remove"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label>{{ $ml.get('filters.filterState') }}</label>
                    <div class="input-group">
                      <label v-show="checkedStateList != ''" class="form-control tdb-box">{{ checkedStateList }}</label>
                      <label v-show="checkedStateList == ''"
                        class="form-control">{{ $ml.get('general.notSelected') }}</label>
                      <div class="input-group-btn">
                        <button class="btn btn-default" data-toggle="modal" data-target="#modal-select-state">
                          <i class="fa fa-search"></i>
                        </button>
                        <button v-show="checkedStateList != ''" class="btn btn-danger" @click="clearFilterStates()">
                          <i class="fa fa-remove"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="form-group col-sm-6">
                      <span>{{ $ml.get('filters.filterDeleted') }}</span>
                      <span class="form-control checkbox">
                        <label style="margin-left:20px;">
                          <input :checked="filters.isActive"
                            @change="filters.isActive == true ? filters.isActive = false : filters.isActive = true"
                            type="checkbox" />
                          {{ $ml.get('filters.filterNotShow') }}
                        </label>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="callout callout-info" style="margin-top:10px;">
                <div class="row">
                  <div class="col-md-3 col-xs-6">
                    <select @change="changeFilterExtraField1($event)" class="form-control input-sm"
                      style="margin-bottom:5px;">
                      <option :selected="filters.extraField1key == 0" value>
                        {{ $ml.get('filters.filterSelectExtraFields') }}</option>
                      <option v-for="extraField in extraFieldList" :key="extraField.id" :value="extraField.id"
                        :selected="extraField.id == filters.extraField1key">{{ extraField.name }}</option>
                    </select>
                  </div>
                  <div class="col-md-3 col-xs-6">
                    <input v-model="filters.extraField1value" type="text" class="form-control input-sm"
                      :placeholder="$ml.get('filters.filterValue')" style="margin-bottom:5px;" />
                  </div>
                  <div class="col-md-3 col-xs-6">
                    <select @change="changeFilterExtraField2($event)" class="form-control input-sm"
                      style="margin-bottom:5px;">
                      <option :selected="filters.extraField2key == 0" value>
                        {{ $ml.get('filters.filterSelectExtraFields') }}</option>
                      <option v-for="extraField in extraFieldList" :key="extraField.id" :value="extraField.id"
                        :selected="extraField.id == filters.extraField2key">{{ extraField.name }}</option>
                    </select>
                  </div>
                  <div class="col-md-3 col-xs-6">
                    <input v-model="filters.extraField2value" type="text" class="form-control input-sm"
                      :placeholder="$ml.get('filters.filterValue')" style="margin-bottom:5px;" />
                  </div>
                  <div class="col-md-3 col-xs-6">
                    <select @change="changeFilterExtraField3($event)" class="form-control input-sm"
                      style="margin-bottom:5px;">
                      <option :selected="filters.extraField3key == 0" value>
                        {{ $ml.get('filters.filterSelectExtraFields') }}</option>
                      <option v-for="extraField in extraFieldList" :key="extraField.id" :value="extraField.id"
                        :selected="extraField.id == filters.extraField3key">{{ extraField.name }}</option>
                    </select>
                  </div>
                  <div class="col-md-3 col-xs-6">
                    <input v-model="filters.extraField3value" type="text" class="form-control input-sm"
                      :placeholder="$ml.get('filters.filterValue')" style="margin-bottom:5px;" />
                  </div>
                  <div class="col-md-3 col-xs-6">
                    <select @change="changeFilterExtraField4($event)" class="form-control input-sm"
                      style="margin-bottom:5px;">
                      <option :selected="filters.extraField4key == 0" value>
                        {{ $ml.get('filters.filterSelectExtraFields') }}</option>
                      <option v-for="extraField in extraFieldList" :key="extraField.id" :value="extraField.id"
                        :selected="extraField.id == filters.extraField4key">{{ extraField.name }}</option>
                    </select>
                  </div>
                  <div class="col-md-3 col-xs-6">
                    <input v-model="filters.extraField4value" type="text" class="form-control input-sm"
                      :placeholder="$ml.get('filters.filterValue')" style="margin-bottom:5px;" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal">
              <i class="fa fa-remove"></i>
              <span>{{ $ml.get('filters.filterCancel') }}</span>
            </button>
            <button @click="filtersClear()" class="btn btn-warning ">
              <i class="fa fa-trash-o"></i>
              <span>{{ $ml.get('filters.filterClear') }}</span>
            </button>
            <button @click="getEmployees()" class="btn btn-success " data-dismiss="modal">
              <i class="fa fa-search"></i>
              <span>{{ $ml.get('filters.filterApply') }}</span>
            </button>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!--DEPARTMAN SEÇ MODAL -->
      <div class="modal modal-secondary fade" id="modal-select-department" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('filters.filterDepartments') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <a @click="isCheckDeps == true ? getCheckDepartmentAll(false) : getCheckDepartmentAll(true)">
                <span v-text="isCheckDeps == true ? $ml.get('general.removeAll') : $ml.get('general.selectAll')"></span>
              </a>
              <div v-show="sortableDepartmentList.length > 0" class="table-responsive"
                style="max-height:600px;owerflow:auto;">
                <span class="form-control checkbox" v-for="dep in sortableDepartmentList" :key="dep.id">
                  <label style="margin-left:20px;">
                    <input :checked="dep.check"
                      @change="dep.check == true ? changeFilterDep(dep, false) : changeFilterDep(dep, true)"
                      type="checkbox" />
                    {{ dep.name }}
                  </label>
                </span>
                <div class="callout callout-warning" v-show="sortableDepartmentList.length == 0">
                  {{ $ml.get('employees.departmentNotRecord') }}</div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal">
                <i class="fa fa-check"></i>
                {{ $ml.get('general.done') }}
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--DEPARTMAN SEÇ MODAL END -->
      <!--DURUM SEÇ MODAL -->
      <div class="modal modal-secondary fade" id="modal-select-state" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('filters.filterState') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="table-responsive" style="max-height:600px;owerflow:auto;">
                <span class="form-control checkbox" v-for="state in stateList" :key="state.id">
                  <label style="margin-left:20px;">
                    <input :checked="state.isCheck"
                      @change="state.isCheck == true ? state.isCheck = false : state.isCheck = true" type="checkbox" />
                    {{ state.name }}
                  </label>
                </span>
                <div class="callout callout-warning" v-show="stateList.length == 0">
                  {{ $ml.get('employees.stateNotRecord') }}</div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal">
                <i class="fa fa-check"></i>
                {{ $ml.get('general.done') }}
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--DURUM SEÇ MODAL END -->
      <!--STATU SEÇ MODAL -->
      <div class="modal modal-secondary fade" id="modal-select-status" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('filters.filterStatus') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="table-responsive" style="max-height:600px;owerflow:auto;">
                <span class="form-control checkbox" v-for="status in statuList" :key="status.id">
                  <label style="margin-left:20px;">
                    <input :checked="status.isCheck"
                      @change="status.isCheck == true ? status.isCheck = false : status.isCheck = true" type="checkbox" />
                    {{ status.name }}
                  </label>
                </span>
                <div class="callout callout-warning" v-show="statuList.length == 0">
                  {{ $ml.get('employees.statusNotRecord') }}</div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal">
                <i class="fa fa-check"></i>
                {{ $ml.get('general.done') }}
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--STATU SEÇ MODAL END -->
      <!--GEÇİŞ GRUBU SEÇ MODAL -->
      <div class="modal modal-secondary fade" id="modal-select-access" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('filters.filterAccessGroup') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="table-responsive" style="max-height:600px;owerflow:auto;">
                <span class="form-control checkbox" v-for="acc in accessGroupList" :key="acc.id">
                  <label style="margin-left:20px;">
                    <input :checked="acc.isCheck" @change="acc.isCheck == true ? acc.isCheck = false : acc.isCheck = true"
                      type="checkbox" />
                    {{ acc.name }}
                  </label>
                </span>
                <div class="callout callout-warning" v-show="accessGroupList.length == 0">
                  {{ $ml.get('accessGroups.accessGroupNotRecord') }}</div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal">
                <i class="fa fa-check"></i>
                {{ $ml.get('general.done') }}
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--GEÇİŞ GRUBU SEÇ MODAL END -->
      <!--ÇALIŞMA PLANI SEÇ MODAL -->
      <div class="modal modal-secondary fade" id="modal-select-workplan" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('filters.filterWorkPlan') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="table-responsive" style="max-height:600px;owerflow:auto;">
                <span class="form-control checkbox" v-for="work in periodWorkGroupList" :key="work.id">
                  <label style="margin-left:20px;">
                    <input :checked="work.isCheck" @change="work.isCheck == true ? work.isCheck = false : work.isCheck = true"
                      type="checkbox" />
                    {{ work.name }}
                  </label>
                </span>
                <div class="callout callout-warning" v-show="periodWorkGroupList.length == 0">
                  {{ $ml.get('workPlans.workPlanNotRecord') }}</div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal">
                <i class="fa fa-check"></i>
                {{ $ml.get('general.done') }}
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--ÇALIŞMA PLANI SEÇ MODAL END -->
      <!--YEMEK PLANI SEÇ MODAL -->
      <div class="modal modal-secondary fade" id="modal-select-diningHall" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('filters.filterWorkPlan') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="table-responsive" style="max-height:600px;owerflow:auto;">
                <span class="form-control checkbox" v-for="foodGroup in foodGroupList" :key="foodGroup.id">
                  <label style="margin-left:20px;">
                    <input :checked="foodGroup.isCheck"
                      @change="foodGroup.isCheck == true ? foodGroup.isCheck = false : foodGroup.isCheck = true"
                      type="checkbox" />
                    {{ foodGroup.name }}
                  </label>
                </span>
                <div class="callout callout-warning" v-show="foodGroupList.length == 0">
                  {{ $ml.get('foodGroups.foodGroupNotRecord') }}</div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal">
                <i class="fa fa-check"></i>
                {{ $ml.get('general.done') }}
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--YEMEK PLANI SEÇ MODAL END -->
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isLoading: false,
      isLoadingEmployee: false,
      isLoadingInOuts: false,
      isLoadingPayrolls: false,
      windowHeight: window.innerHeight,
      searchText: "",
      orderEmpList: 1,
      startDate: null,
      endDate: null,
      selectedEmployeeId: null,
      payrollDatas: [],
      checkedRows: [],
      detailData: {
        calculatedOverTime: "00:00",
        confirmedOverTime: "00:00",
        date: "",
        firstEntry: "",
        firstEntryModified: true,
        firstEntryModifiedUserName: "",
        lastExit: "",
        lastExitModified: true,
        lastExitModifiedUserName: "",
        holidayDescription: null,
        missingHour: "",
        totalWorkTime: "",
        workPlan: "",
        check: true,
        name: "",
        registrationNumber: "",
        employeeId: 0
      },
      selectedDateDetails: [],
      isNewInOut: false,
      newInOut: {
        date: "00:00",
        inOrOut: 1,
        readerId: 1
      },
      filters: {
        nameOrCardNumber: "",
        sicilOrTerminalNo: null,
        departments: [],
        accessGroup: [],
        identityNo: "",
        documentNoOrMail: "",
        foodGroup: [],
        workGroupId: [],
        title: "",
        stateId: [],
        statuId: [],
        plateNo: "",
        extraField1key: 0,
        extraField1value: "",
        extraField2key: 0,
        extraField2value: "",
        extraField3key: 0,
        extraField3value: "",
        extraField4key: 0,
        extraField4value: "",
        isVisitor: false,
        isActive: true
      },
      isCheckDeps: false,
      readers: [],
      extrafields: [],
      workGroups: [],
      allowences: [],
      status: [],
      states: [],
      foodGroups: [],
      titles: [],
      accessGroups: [],
      departments: [],
      sortableDepTrees: [],
      employees: [],
      employee: {
        id: null,
        name: "",
        title: "",
        sicilNo: "",
        image: null,
        departmentId: null,
        identityNo: "",
        startDate: null,
        endDate: null,
        workGroupId: null,
        stateId: 1,
        stateNote: "",
        terminalNo: null,
        statuId: null,
        cardNo: "",
        terminalStatu: 0,
        terminalPassword: "",
        plateNo: "",
        hgsNo: "",
        tzCode: "",
        accessGroupId: null,
        readers: [],
        overWorkStatus: true,
        salary: null,
        mail: "",
        address: "",
        mobilePhone: "",
        birthDayDate: null,
        validityDate: null,
        internalPhone: "",
        homePhone: "",
        gender: null,
        educationStatus: null,
        militaryStatus: null,
        drivingLicence: "",
        smokeStatus: null,
        maritalStatus: null,
        bloodType: "",
        height: "",
        weight: "",
        disabledPercent: "",
        authorizedPerson1: null,
        authorizedPerson2: null,
        note1: "",
        note2: "",
        foreignLanguage: "",
        foodGroupId: null,
        credit: 0,
        remainder: "0",
        isVisitor: false,
        visitorCardGroupId: null,
        visitorArea: "",
        isActive: true,
        extrafields: [],
        inOuts: [],
        allowences: [],
        logs: [],
        empPayrolls: [],
        annualPermitId: 0,
        annualPermitSeniority: 0,
        annualPermitTransfer: 0,
        annualPermitClaim: 0,
        annualPermitUsed: 0,
        annualPermitRemain: 0,
        annualPermits: [],
        annualPermitClaimsDates: [],
        salaries: [],
        hasCard: false,
        hasFace: false,
        hasFinger: false,
        hasPassword: false,
        roomId: 0,
        roomName: "",
        areaName: "",
        floorName: "",
        fingerIndexes: [],
        isSmsSend: false,
        parentPhone: null,
        isStudent: false,
        isStayInDormitory: false,
        motherName: "",
        motherPhone: "",
        fatherName: "",
        fatherPhone: ""
      }
    };
  },
  computed: {
    defaultFilters() {
      return this.$store.getters.getDefaultFilters;
    },
    modules() {
      return this.$store.getters.getModules;
    },
    readerList() {
      return this.readers;
    },
    isCheckedRowList() {
      return this.checkedRows;
    },
    selectedDateDetailList() {
      return this.selectedDateDetails;
    },
    filtered() {
      if (this.searchText) {
        return this.payrollDataList.filter(item => {
          return this.searchText
            .toUpperCase()
            .split(" ")
            .every(
              v =>
                item.name.toUpperCase().includes(v) ||
                item.registrationNumber.toUpperCase().includes(v)
            );
        });
      } else {
        return this.payrollDataList;
      }
    },
    departmentList() {
      return this.departments;
    },
    sortableDepartmentList() {
      return this.sortableDepTrees;
    },
    checkedDepartmentList() {
      var checkedList = "";
      var list = this.sortableDepTrees.forEach(a => {
        if (a.check == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    employeeList() {
      return this.employees;
    },
    payrollDataList() {
      if (this.orderEmpList == 1) {
        return this.payrollDatas.sort((a, b) => {
          return a.registrationNumber
            .toUpperCase()
            .localeCompare(b.registrationNumber.toUpperCase());
        });
      } else if (this.orderEmpList == 2) {
        return this.payrollDatas.sort((a, b) => {
          return b.registrationNumber
            .toUpperCase()
            .localeCompare(a.registrationNumber.toUpperCase());
        });
      } else if (this.orderEmpList == 3) {
        return this.payrollDatas.sort((a, b) => {
          return a.name.toUpperCase().localeCompare(b.name.toUpperCase());
        });
      } else {
        return this.payrollDatas.sort((a, b) => {
          return b.name.toUpperCase().localeCompare(a.name.toUpperCase());
        });
      }
    },
    titleList() {
      return this.titles;
    },
    stateList() {
      return this.states;
    },
    checkedStateList() {
      var checkedList = "";
      var list = this.stateList.forEach(a => {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    statuList() {
      return this.status;
    },
    checkedStatusList() {
      var checkedList = "";
      var list = this.statuList.forEach(a => {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    extraFieldList() {
      return this.extrafields;
    },
    workGroupList() {
      return this.workGroups;
    },
    allowenceList() {
      return this.allowences;
    },
    periodWorkGroupList() {
      return this.workGroups.filter(item => {
        return item.isPeriod == true || item.model == 4 || item.model == 3;
      });
    },
    checkedWorkGroupList() {
      var checkedList = "";
      var list = this.periodWorkGroupList.forEach(a => {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    accessGroupList() {
      return this.accessGroups;
    },
    checkedAccessGroupList() {
      var checkedList = "";
      var list = this.accessGroupList.forEach(a => {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    foodGroupList() {
      return this.foodGroups;
    },
    checkedFoodGroupList() {
      var checkedList = "";
      var list = this.foodGroupList.forEach(a => {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    windowHeightSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 220;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
        //WEB
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  methods: {
    toDateFormatGet(str) {
      if (!str || str == "-") {
        return "-";
      }
      var gun = str.substr(0, 2);
      var ay = str.substr(3, 2);
      var yil = str.substr(6, 4);
      var saat = str.substr(11, 2);
      var dakika = str.substr(14, 2);
      var saniye = str.substr(17, 2);
      return saat + ":" + dakika;
    },
    toDateFormat(str, format) {
      if (str.length > 9) {
        str = new Date(str);
      } else {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
      }
      if (format == "gg.aa.yyyy ss:dd") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return yil + "-" + ay + "-" + gun;
      } else if (format == "ss:dd:ss") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        var saniye =
          str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return saat + ":" + dakika;
      }
    },
    onResize() {
      this.windowHeight = window.innerHeight;
    },
    exportToExcel() {
      if (this.payrollDataList.length == 0) {
        alertify.warning("Lütfen önce verileri görüntüleyin...");
        return;
      }
      var tarih = new Date();
      var filename = "Puantaj Özeti - " + tarih.toLocaleString();
      $("#printExcel").table2excel({
        filename: filename + ".xls",
        preserveColors: true
      });
    },
    setOrderEmp(number) {
      if (number == 1) {
        if (this.orderEmpList == 1) {
          this.orderEmpList = 2;
        } else {
          this.orderEmpList = 1;
        }
      } else {
        if (this.orderEmpList == 3) {
          this.orderEmpList = 4;
        } else {
          this.orderEmpList = 3;
        }
      }
    },
    changeSelectedReader(event) {
      this.newInOut.readerId = event.target.value;
    },
    changeFilterTitles(event) {
      this.filters.title = event.target.value;
    },
    changeFilterExtraField1(event) {
      this.filters.extraField1key = event.target.value;
      if (!this.filters.extraField1key) {
        this.filters.extraField1key = 0;
      }
    },
    changeFilterExtraField2(event) {
      this.filters.extraField2key = event.target.value;
      if (!this.filters.extraField2key) {
        this.filters.extraField2key = 0;
      }
    },
    changeFilterExtraField3(event) {
      this.filters.extraField3key = event.target.value;
      if (!this.filters.extraField3key) {
        this.filters.extraField3key = 0;
      }
    },
    changeFilterExtraField4(event) {
      this.filters.extraField4key = event.target.value;
      if (!this.filters.extraField4key) {
        this.filters.extraField4key = 0;
      }
    },
    filtersClear() {
      this.filters.nameOrCardNumber = "";
      this.filters.sicilOrTerminalNo = null;
      this.filters.departments = [];
      this.filters.accessGroup = [];
      this.filters.identityNo = "";
      this.filters.documentNoOrMail = "";
      this.filters.foodGroup = [];
      this.filters.workGroupId = [];
      this.filters.title = "";
      this.filters.stateId = [];
      this.filters.statuId = [];
      this.filters.plateNo = "";
      this.filters.extraField1key = 0;
      this.filters.extraField1value = "";
      this.filters.extraField2key = 0;
      this.filters.extraField2value = "";
      this.filters.extraField3key = 0;
      this.filters.extraField3value = "";
      this.filters.extraField4key = 0;
      this.filters.extraField4value = "";
      this.filters.isVisitor = false;
      this.filters.isActive = true;
      this.accessGroupList.forEach(a => {
        a.isCheck = false;
      });
      this.sortableDepartmentList.forEach(a => {
        a.check = false;
      });
      this.foodGroupList.forEach(a => {
        a.isCheck = false;
      });
      this.workGroupList.forEach(a => {
        a.isCheck = false;
      });
      this.stateList.forEach(a => {
        a.isCheck = false;
      });
      this.statuList.forEach(a => {
        a.isCheck = false;
      });
    },
    async getAccessGroups() {
      try {
        const accessGroups = [];
        const response = await this.$axios
          .get("/AccessGroups")
          .then(response => {
            response.data.forEach(doc => {
              accessGroups.push({
                id: doc.id,
                name: doc.name,
                isNewReaderAdd: doc.isNewReaderAdd,
                selectedReaders: doc.postReaders,
                isCheck: false
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.accessGroups = accessGroups;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getDepartments() {
      const departments = [];
      try {
        const response = await this.$axios
          .get("/Department")
          .then(response => {
            response.data.forEach(doc => {
              departments.push({
                id: doc.id,
                name: doc.name,
                mainDepartmentId: doc.mainDepartmentId,
                isActive: doc.isActive,
                locationTree: doc.locationTree,
                check: false
              });
            });
            departments.sort((a, b) => {
              if (a.locationTree < b.locationTree) return -1;
              if (a.locationTree > b.locationTree) return 0;
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.departments = departments;
        this.sortableTrees();
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error(error);
      }
    },
    sortableTrees() {
      this.sortableDepTrees = [];
      this.departments.forEach(dep => {
        if (dep.mainDepartmentId == null) {
          this.sortableDepTrees.push(dep);
          this.subDepImport(dep);
        }
      });
    },
    subDepImport(dep) {
      let subDep = this.departments.filter(function (doc) {
        return doc.mainDepartmentId == dep.id;
      });
      if (subDep.length > 0) {
        var ekle = "";
        let ek = subDep[0].locationTree.split("/");
        for (let index = 0; index < ek.length - 3; index++) {
          ekle = "--/" + ekle;
        }
        subDep.forEach(doc2 => {
          this.sortableDepTrees.push({
            id: doc2.id,
            name: ekle + " " + doc2.name,
            mainDepartmentId: doc2.mainDepartmentId,
            isActive: doc2.isActive,
            locationTree: doc2.locationTree,
            userId: doc2.userId,
            check: doc2.check
          });
          this.subDepImport(doc2);
        });
      }
    },
    async getFoodGroups() {
      try {
        const foodGroups = [];
        const response = await this.$axios
          .get("/FoodGroups")
          .then(response => {
            response.data.forEach(doc => {
              foodGroups.push({
                id: doc.id,
                name: doc.name,
                type: doc.type,
                singleFoodEachMeal: doc.singleFoodEachMeal,
                meals: doc.meals,
                isCheck: false
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.foodGroups = foodGroups;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getStatus() {
      try {
        const status = [];
        const response = await this.$axios
          .get("/Employees/getStatus")
          .then(response => {
            response.data.forEach(doc => {
              status.push({
                id: doc.id,
                name: doc.name,
                isCheck: false
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.status = status;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getTitles() {
      try {
        const titles = [];
        const response = await this.$axios
          .get("/Employees/getTitles")
          .then(response => {
            response.data.forEach(doc => {
              titles.push({
                name: doc
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.titles = titles;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getStates() {
      try {
        const states = [];
        const response = await this.$axios
          .get("/Employees/getStates")
          .then(response => {
            response.data.forEach(doc => {
              states.push({
                id: doc.id,
                name: doc.name,
                status: doc.status,
                isCheck: false
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.states = states;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getWorkGroups() {
      try {
        const workGroups = [];
        const response = await this.$axios
          .get("/WorkGroups")
          .then(response => {
            response.data.forEach(doc => {
              workGroups.push({
                id: doc.id,
                name: doc.name,
                shortCode: doc.shortCode,
                isPeriod: doc.isPeriod,
                model: doc.model,
                isCheck: false
              });
              workGroups.sort((a, b) => {
                if (a.name < b.name) return -1;
                if (a.name > b.name) return 0;
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.workGroups = workGroups;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getExtraFields() {
      try {
        const extrafields = [];
        const response = await this.$axios
          .get("/ExtraField")
          .then(response => {
            response.data.forEach(doc => {
              extrafields.push({
                id: doc.id,
                name: doc.definition
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.extrafields = extrafields;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async changeFilterDep(dep, checkValue) {
      dep.check = checkValue;
      this.sortableDepartmentList.forEach(doc => {
        if (doc.mainDepartmentId == dep.id) {
          doc.check = checkValue;
          this.changeFilterDep(doc, checkValue);
        }
      });
    },
    async clearFilterDepartments() {
      this.filters.departments = [];
      await this.sortableDepartmentList.forEach(doc => {
        if (doc.check == true) {
          doc.check = false;
        }
      });
    },
    async clearFilterAccessGroup() {
      this.filters.accessGroup = [];
      await this.accessGroupList.forEach(doc => {
        if (doc.isCheck == true) {
          doc.isCheck = false;
        }
      });
    },
    async clearFilterStates() {
      this.filters.stateId = [];
      await this.stateList.forEach(doc => {
        if (doc.isCheck == true) {
          doc.isCheck = false;
        }
      });
    },
    async clearFilterStatus() {
      this.filters.statuId = [];
      await this.statuList.forEach(doc => {
        if (doc.isCheck == true) {
          doc.isCheck = false;
        }
      });
    },
    async clearFilterWorkPlans() {
      this.filters.workGroupId = [];
      await this.workGroupList.forEach(doc => {
        if (doc.isCheck == true) {
          doc.isCheck = false;
        }
      });
    },
    async clearFilterFoodGroups() {
      this.filters.foodGroup = [];
      await this.foodGroupList.forEach(doc => {
        if (doc.isCheck == true) {
          doc.isCheck = false;
        }
      });
    },
    async getCheckDepartmentAll(value) {
      this.sortableDepartmentList.forEach(dep => {
        dep.check = value;
      });
      this.isCheckDeps = !this.isCheckDeps;
    },
    async getCheckDepartmentList() {
      let aList = this.sortableDepartmentList;
      this.filters.departments = [];
      await aList.forEach(doc => {
        if (doc.check == true) {
          this.filters.departments.push(doc.id);
        }
      });
      let aList2 = this.accessGroupList;
      this.filters.accessGroup = [];
      await aList2.forEach(doc => {
        if (doc.isCheck == true) {
          this.filters.accessGroup.push(doc.id);
        }
      });
      let aList3 = this.workGroupList;
      this.filters.workGroupId = [];
      await aList3.forEach(doc => {
        if (doc.isCheck == true) {
          this.filters.workGroupId.push(doc.id);
        }
      });
      let aList4 = this.foodGroupList;
      this.filters.foodGroup = [];
      await aList4.forEach(doc => {
        if (doc.isCheck == true) {
          this.filters.foodGroup.push(doc.id);
        }
      });
      let aList5 = this.statuList;
      this.filters.statuId = [];
      await aList5.forEach(doc => {
        if (doc.isCheck == true) {
          this.filters.statuId.push(doc.id);
        }
      });
      let aList6 = this.stateList;
      this.filters.stateId = [];
      await aList6.forEach(doc => {
        if (doc.isCheck == true) {
          this.filters.stateId.push(doc.id);
        }
      });
    },
    async getSelectedEmployeeList() {
      let aList = this.employees;
      var selectedEmployeeList = [];
      await aList.forEach(emp => {
        selectedEmployeeList.push(emp.id);
      });
      return selectedEmployeeList;
    },
    async deleteMovement(empId, empName, date, movement, registrationNumber) {
      try {
        if (movement.id != 0 && movement.id != null) {
          const response = await this.$axios
            .delete("/EmployeeDetails/DeleteEntryExit/" + movement.id)
            .then(response => {
              alertify.success(this.$ml.get("alerts.deletedSuccessfully"));
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              }
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingInOuts = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingInOuts = false;
                return;
              }
            });
          await this.getPayrollDetail({
            isOpen: false,
            employeeId: empId,
            name: empName,
            registrationNumber: registrationNumber
          });
          for (var i = 0; i < this.selectedDateDetails.length; i++) {
            if (
              this.selectedDateDetails[i].employeeId == empId &&
              this.selectedDateDetails[i].date == date
            ) {
              this.selectedDateDetails.splice(i, 1);
            }
          }
          this.getDailyPayrollDetails(date, empId, empName, registrationNumber);
        }
      } catch (error) {
        alertify.error("Hata Oluştu : " + error);
      }
    },
    clearInOut() {
      this.isNewInOut = true;
      this.newInOut.date = "00:00";
      this.newInOut.inOrOut = 1;
      this.newInOut.readerId = 1;
    },
    async saveMovement(date, empId, empName, registrationNumber) {
      if (this.newInOut.date == "") {
        alertify.warning(this.$ml.get("alerts.invalidDate"));
        return;
      }
      if (this.newInOut.readerId == "" || this.newInOut.readerId == 0) {
        alertify.warning(this.$ml.get("alerts.notSelectedReader"));
        return;
      }
      if (!date || date == "-") {
        return "-";
      }
      var gun = date.substr(0, 2);
      var ay = date.substr(3, 2);
      var yil = date.substr(6, 4);
      var date2 = new Date(
        yil + "-" + ay + "-" + gun + "T" + this.newInOut.date + ":00.000Z"
      );
      var today = new Date();
      if (date2 > today) {
        alertify.warning(
          this.$ml.get("alerts.cannotCreateMovementInTheFuture")
        );
        return;
      }
      try {
        let empId2 = empId;
        let inOurOut = this.newInOut.inOrOut;
        let inOutAdd = date2.toISOString();
        let readerId = this.newInOut.readerId;
        const response = await this.$axios
          .post("/EmployeeDetails/AddEntryExit", {
            isActive: true,
            inOrOut: inOurOut,
            date: inOutAdd,
            readerId: readerId,
            includePassiveMovements: false,
            doNotDeleteOvertimes: false,
            empId: empId2
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            }
            if (
              error.message == "Network Error" ||
              error.message == "Error: Network Error"
            ) {
              alertify.error(this.$ml.get("errors.connectionError"));
              this.isLoadingInOuts = false;
              return;
            } else {
              console.error(error);
              alertify.error(error.message);
              this.isLoadingInOuts = false;
              return;
            }
          });
        if (response.status == 200) {
          alertify.success(this.$ml.get("alerts.savedSuccessfully"));
        } else if (response.status == 201) {
          alertify.error(this.$ml.get("alerts.checkTheMealTime"));
        } else {
          alertify.error(response.message);
        }
        await this.getPayrollDetail({
          isOpen: false,
          employeeId: empId2,
          name: empName,
          registrationNumber: ""
        });
        for (var i = 0; i < this.selectedDateDetails.length; i++) {
          if (
            this.selectedDateDetails[i].employeeId == empId2 &&
            this.selectedDateDetails[i].date == date
          ) {
            this.selectedDateDetails.splice(i, 1);
          }
        }
        this.getDailyPayrollDetails(date, empId2, empName, registrationNumber);
        this.clearInOut();
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
      }
    },
    async updateMovement(empId, empName, date, movement, registrationNumber) {
      if (movement.date == "") {
        alertify.warning(this.$ml.get("alerts.invalidDate"));
        return;
      }
      if (movement.readerId == "" || movement.readerId == 0) {
        alertify.warning(this.$ml.get("alerts.notSelectedReader"));
        return;
      }
      var date3 = this.toDateFormat(
        String(movement.unFormattedDate),
        "gg.aa.yyyy"
      );
      var date2 = new Date(date3 + "T" + movement.date + ":00.000Z");
      var today = new Date();
      if (date2 > today) {
        alertify.warning(
          this.$ml.get("alerts.cannotCreateMovementInTheFuture")
        );
        return;
      }
      try {
        let empId2 = empId;
        let inOurOut = movement.inOrOut;
        let inOutAdd = date2.toISOString();
        let readerId = movement.readerId;
        const response = await this.$axios.post(
          "/EmployeeDetails/UpdateEntryExit/" + movement.id,
          {
            isActive: true,
            inOrOut: inOurOut,
            date: inOutAdd,
            empId: empId2,
            readerId: readerId
          }
        );
        if (response.status == 200) {
          alertify.success(this.$ml.get("alerts.savedSuccessfully"));
        } else {
          alertify.error(response.message);
        }
        await this.getPayrollDetail({
          isOpen: false,
          employeeId: empId2,
          name: empName,
          registrationNumber: registrationNumber
        });
        for (var i = 0; i < this.selectedDateDetails.length; i++) {
          if (
            this.selectedDateDetails[i].employeeId == empId2 &&
            this.selectedDateDetails[i].date == date
          ) {
            this.selectedDateDetails.splice(i, 1);
          }
        }
        this.getDailyPayrollDetails(date, empId2, empName, registrationNumber);
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
      }
    },
    async deleteOverTime(id, date, empId, empName, registrationNumber) {
      try {
        this.isLoadingPayrolls = true;
        const response = await this.$axios
          .delete("/EmployeeDetails/DeleteConfirmOvertime/" + id)
          .then(response => {
            if (response.status == 200) {
              alertify.success(this.$ml.get("alerts.confirmedOvertimeDeleted"));
            } else {
              response.statusText + " - " + response.data.message;
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingPayrolls = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingPayrolls = false;
                return;
              }
            }
          });
        await this.getPayrollDetail({
          isOpen: false,
          employeeId: empId,
          name: empName,
          registrationNumber: registrationNumber
        });
        for (var i = 0; i < this.selectedDateDetails.length; i++) {
          if (
            this.selectedDateDetails[i].employeeId == empId &&
            this.selectedDateDetails[i].date == date
          ) {
            this.selectedDateDetails.splice(i, 1);
          }
        }
        this.getDailyPayrollDetails(date, empId, empName, registrationNumber);
        this.isLoadingPayrolls = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoadingPayrolls = false;
      }
    },
    async confirmOverTime(
      overTimeId,
      confirmed,
      calculated,
      date,
      empId,
      empName,
      registrationNumber
    ) {
      try {
        let id = overTimeId;
        let calculatedDate = "1900-01-01T" + calculated + ":00";
        let confirmedDate = "1900-01-01T" + calculated;
        if (confirmedDate > calculatedDate) {
          alertify.warning(
            this.$ml.get(
              "alerts.confirmedOvertimeCannotBeGreaterThanCalculated"
            )
          );
          return;
        }
        this.isLoadingPayrolls = true;
        const response = await this.$axios
          .post("/EmployeeDetails/CustomConfirmOvertime", {
            id: id,
            confirmedDate: confirmedDate,
            overtimeDescriptionId: null,
            overtimePlaceId: null
          })
          .then(response => {
            if (response.status == 200) {
              alertify.success(this.$ml.get("alerts.savedSuccessfully"));
              this.isLoadingPayrolls = false;
            }
          })
          .catch(doc => {
            if (doc.status == 401) {
              this.$store.dispatch("logout");
            } else if (doc.message == "Network Error") {
              alertify.error(this.$ml.get("errors.connectionError"));
            } else {
              alertify.error(doc.message);
            }
          });
        await this.getPayrollDetail({
          isOpen: false,
          employeeId: empId,
          name: empName,
          registrationNumber: registrationNumber
        });
        for (var i = 0; i < this.selectedDateDetails.length; i++) {
          if (
            this.selectedDateDetails[i].employeeId == empId &&
            this.selectedDateDetails[i].date == date
          ) {
            this.selectedDateDetails.splice(i, 1);
          }
        }
        this.getDailyPayrollDetails(date, empId, empName, registrationNumber);
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
      }
    },
    async getDailyPayrollDetails(tarih, empId, empName, registrationNumber) {
      try {
        var dateDetail = {
          employeeId: empId,
          employeeName: empName,
          registrationNumber: registrationNumber,
          date: tarih,
          overtimes: {
            calculated: "",
            confirmed: "",
            overTimeId: null
          },
          movements: [],
          payrolls: []
        };
        var docc = tarih.split(".");
        var inOutAdd = docc[2] + "-" + docc[1] + "-" + docc[0] + "T00:00";
        const response = await this.$axios
          .post("/EmployeeDetails/GetDailyPayrollDetails", {
            date: tarih,
            empId: empId
          })
          .then(response => {
            if (response.status == 200) {
              if (response.data.overtimes) {
                dateDetail.overtimes = response.data.overtimes;
              } else {
                dateDetail.overtimes.calculated = "00:00";
                dateDetail.overtimes.confirmed = "00:00";
                dateDetail.overtimes.overTimeId = null;
              }
              response.data.movements.forEach(a => {
                var ss = this.toDateFormat(a.unFormattedDate, "ss:dd");
                dateDetail.movements.push({
                  date: ss,
                  id: a.id,
                  inOrOut: a.inOrOut,
                  readerId: a.readerId,
                  status: a.status,
                  unFormattedDate: a.unFormattedDate,
                  check: false
                });
              });
              dateDetail.payrolls = response.data.payrolls;
            }
          })
          .catch(doc => {
            if (doc.status == 401) {
              this.$store.dispatch("logout");
            } else if (doc.message == "Network Error") {
              alertify.error(this.$ml.get("errors.connectionError"));
            } else {
              alertify.error(doc.message);
            }
          });
        this.selectedDateDetails.push(dateDetail);
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
      }
    },
    changeWorkPlan(detail) {
      this.detailData = detail;
      $('#changePayroll').modal('show');
    },
    async checkRow(detail) {
      this.detailData = detail;
      detail.check = !detail.check;
      if (detail.check == true) {
        this.getDailyPayrollDetails(
          detail.date,
          detail.employeeId,
          detail.name,
          detail.registrationNumber
        );
        this.checkedRows.push(detail);
      } else {
        for (var i = 0; i < this.checkedRows.length; i++) {
          if (
            this.checkedRows[i].employeeId == detail.employeeId &&
            this.checkedRows[i].date == detail.date
          ) {
            this.checkedRows.splice(i, 1);
          }
        }
        for (var i = 0; i < this.selectedDateDetails.length; i++) {
          if (
            this.selectedDateDetails[i].employeeId == detail.employeeId &&
            this.selectedDateDetails[i].date == detail.date
          ) {
            this.selectedDateDetails.splice(i, 1);
          }
        }
      }
    },
    async setChangePayroll(contextId, isAllowence) {
      if (this.detailData == null || this.detailData.employeeId == 0) {
        alertify.warning("Lütfen seçim yapınız...");
        return;
      }
      try {
        this.isLoadingEmployee = true;
        var data = [];
          data.push({
            empId: this.detailData.employeeId,
            date: this.detailData.date,
            contextId: contextId,
            isAllowence: isAllowence
          });
          console.log(data);
        const response = await this.$axios
          .post("/Shift/ChangePayroll", data)
          .then(response => {
            this.getPayrollDetail(this.detailData);
            alertify.success("İşlem Tamamlandı!");
            this.isLoadingEmployee = false;
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              } else if (error.response.status == 403) {
                alertify.message(
                  this.$ml.get("alerts.userIsNotAuthorizedToSeeData")
                );
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingEmployee = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingEmployee = false;
                return;
              }
            }
          });
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoadingEmployee = false;
      }
    },
    async getPayrollDetail(emplo) {
      try {
        if (this.startDate == null || this.endDate == null) {
          alertify.warning("Tarihleri kontrol edin...");
          return;
        }
        /*if (emplo.isOpen == true) {
          emplo.isOpen = false;
        }*/
        this.selectedEmployeeId = emplo.employeeId;
        this.isLoadingEmployee = true;
        const response = await this.$axios
          .post("/Shift/Details", {
            employeeId: this.selectedEmployeeId,
            startDate: this.startDate,
            endDate: this.endDate
          })
          .then(response => {
            var a = this.payrollDatas.filter(emp => {
              return emp.employeeId == this.selectedEmployeeId;
            });
            if (a[0]) {
              a[0].isOpen = true;
              a[0].payrollDetails = [];
              response.data.forEach(data => {
                var checked = false;
                var record = this.checkedRows.filter(b => {
                  return (
                    b.date == data.date &&
                    b.employeeId == this.selectedEmployeeId
                  );
                });
                if (record[0]) {
                  checked = true;
                }
                a[0].payrollDetails.push({
                  calculatedOverTime: data.calculatedOverTime,
                  confirmedOverTime: data.confirmedOverTime,
                  date: data.date,
                  firstEntry: data.firstEntry,
                  firstEntryModified: data.firstEntryModified,
                  firstEntryModifiedUserName: data.firstEntryModifiedUserName,
                  lastExit: data.lastExit,
                  lastExitModified: data.lastExitModified,
                  lastExitModifiedUserName: data.lastExitModifiedUserName,
                  holidayDescription: data.holidayDescription,
                  missingHour: data.missingHour,
                  totalWorkTime: data.totalWorkTime,
                  workPlan: data.workPlan,
                  check: checked,
                  name: emplo.name,
                  registrationNumber: emplo.registrationNumber,
                  employeeId: this.selectedEmployeeId
                });
              });
            }
            this.isLoadingEmployee = false;
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              } else if (error.response.status == 403) {
                alertify.message(
                  this.$ml.get("alerts.userIsNotAuthorizedToSeeData")
                );
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingEmployee = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingEmployee = false;
                return;
              }
            }
          });
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoadingEmployee = false;
      }
    },
    async getData() {
      this.selectedDateDetails = [];
      this.checkedRows = [];
      try {
        if (this.startDate == null || this.endDate == null) {
          alertify.warning("Tarihleri kontrol edin...");
          return;
        }
        this.isLoadingEmployee = true;
        var payrollDatas = [];
        let empIds = await this.getSelectedEmployeeList();
        const response = await this.$axios
          .post("/Shift", {
            employeeIds: empIds,
            startDate: this.startDate,
            endDate: this.endDate
          })
          .then(response => {
            response.data.forEach(a => {
              payrollDatas.push({
                employeeId: a.employeeId,
                name: a.name,
                registrationNumber: a.registrationNumber,
                title: a.title,
                totalCalculatedOvertime: a.totalCalculatedOvertime,
                totalConfirmedOvertime: a.totalConfirmedOvertime,
                totalHoliday: a.totalHoliday,
                totalMissingHour: a.totalMissingHour,
                totalWorkTime: a.totalWorkTime,
                workPlan: a.workPlan,
                payrollDetails: [],
                isOpen: false,
                allCheck: false
              });
            });
            this.isLoadingEmployee = false;
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              } else if (error.response.status == 403) {
                alertify.message(
                  this.$ml.get("alerts.userIsNotAuthorizedToSeeData")
                );
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingEmployee = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingEmployee = false;
                return;
              }
            }
          });
        this.payrollDatas = payrollDatas;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoadingEmployee = false;
      }
    },
    async getEmployees() {
      try {
        this.isLoadingEmployee = true;
        await this.getCheckDepartmentList();
        const employees = [];
        let filters2 = this.filters;
        const response = await this.$axios
          .post("/Employees/getByFilter", {
            nameOrCardNumber: filters2.nameOrCardNumber,
            sicilOrTerminalNo: filters2.sicilOrTerminalNo,
            departments: filters2.departments,
            accessGroup: filters2.accessGroup,
            identityNo: filters2.identityNo,
            documentNoOrMail: filters2.documentNoOrMail,
            foodGroup: filters2.foodGroup,
            workGroupId: filters2.workGroupId,
            title: filters2.title,
            stateId: filters2.stateId,
            statuId: filters2.statuId,
            plateNo: filters2.plateNo,
            extraField1key: filters2.extraField1key,
            extraField1value: filters2.extraField1value,
            extraField2key: filters2.extraField2key,
            extraField2value: filters2.extraField2value,
            extraField3key: filters2.extraField3key,
            extraField3value: filters2.extraField3value,
            extraField4key: filters2.extraField4key,
            extraField4value: filters2.extraField4value,
            isVisitor: filters2.isVisitor,
            isActive: filters2.isActive
          })
          .then(response => {
            response.data.forEach(doc => {
              employees.push({
                id: doc.id,
                name: doc.name,
                sicilNo: doc.sicilNo,
                title: doc.title,
                check: false
              });
            });
            //this.filtersClear();
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              } else if (error.response.status == 403) {
                alertify.message(
                  this.$ml.get("alerts.userIsNotAuthorizedToSeeData")
                );
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingEmployee = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingEmployee = false;
                return;
              }
            }
          });
        this.employees = employees;
        this.isLoadingEmployee = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoadingEmployee = false;
      }
    },
    async getAllowences() {
      try {
        const allowences = [];
        const response = await this.$axios
          .get("/Allowences")
          .then(response => {
            response.data.forEach(doc => {
              allowences.push({
                id: doc.id,
                shortCode: doc.shortCode,
                name: doc.name,
                monthlyPayrollId: doc.monthlyPayrollId,
                dailyPayrollId: doc.dailyPayrollId,
                dayTime: doc.dayTime,
                colorCode: doc.colorCode
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.allowences = allowences;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    setUserAuthorityFilter(filter) {
      filter.accessGroup
        ? (this.filters.accessGroup = filter.accessGroup)
        : (this.filters.accessGroup = []);
      filter.foodGroup
        ? (this.filters.foodGroup = filter.foodGroup)
        : (this.filters.foodGroup = []);
      filter.workGroupId
        ? (this.filters.workGroupId = filter.workGroupId)
        : (this.filters.workGroupId = []);
      filter.stateId
        ? (this.filters.stateId = filter.stateId)
        : (this.filters.stateId = []);
      filter.statuId
        ? (this.filters.statuId = filter.statuId)
        : (this.filters.statuId = []);
      this.filters.departments = filter.departments;
      this.filters.nameOrCardNumber = filter.nameOrCardNumber;
      this.filters.sicilOrTerminalNo = filter.sicilOrTerminalNo;
      this.filters.isActive = filter.isActive;
      this.filters.documentNoOrMail = filter.documentNoOrMail;
      this.filters.identityNo = filter.identityNo;
      this.filters.title = filter.title;
      this.filters.extraField1key = filter.extraField1key;
      this.filters.extraField1value = filter.extraField1value;
      this.filters.extraField2key = filter.extraField2key;
      this.filters.extraField2value = filter.extraField2value;
      this.filters.extraField3key = filter.extraField3key;
      this.filters.extraField3value = filter.extraField3value;
      this.filters.extraField4key = filter.extraField4key;
      this.filters.extraField4value = filter.extraField4value;
      this.filters.isVisitor = filter.isVisitor;
      this.filters.plateNo = filter.plateNo;
      //this.filters = filter;
      this.sortableDepartmentList.forEach(doc => {
        this.filters.departments.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.check = true;
          }
        });
      });
      this.periodWorkGroupList.forEach(doc => {
        this.filters.workGroupId.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.accessGroupList.forEach(doc => {
        this.filters.accessGroup.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.foodGroupList.forEach(doc => {
        this.filters.foodGroup.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.stateList.forEach(doc => {
        this.filters.stateId.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.statuList.forEach(doc => {
        this.filters.statuId.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
    },
    async getReaders() {
      try {
        const readers = [];
        const response = await this.$axios
          .get("/Terminal/GetReaders")
          .then(response => {
            if (response.status == 200) {
              response.data.forEach(doc => {
                if (doc.doorType == 1) {
                  readers.push({
                    readerNo: doc.readerNo,
                    readerId: doc.readerId,
                    terminalId: doc.terminalId,
                    terminalNo: doc.terminalNo,
                    ipAddress: doc.ipAddress,
                    isActive: doc.isActive,
                    doorType: doc.doorType,
                    name: doc.name,
                    inOrOut: doc.inOrOut,
                    check: false,
                    VCGcheck: false
                  });
                }
              });
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
              if (error.response.status == 500) {
                alertify.error(this.$ml.get("alerts.getReadersError"));
                this.isLoading = false;
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.readers = readers;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası : " + error.message);
      }
    },
    getDefaultDate() {
      let toDay = new Date();
      var gun = (toDay.getDate() < 10 ? "0" : "") + toDay.getDate();
      var ay = (toDay.getMonth() < 9 ? "0" : "") + (toDay.getMonth() + 1);
      var yil = toDay.getFullYear();
      if (this.startDate == null) {
        this.startDate = yil + "-" + ay + "-" + gun + "T00:00";
      }
      if (this.endDate == null) {
        this.endDate = yil + "-" + ay + "-" + gun + "T23:59";
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  async created() {
    this.getDefaultDate();
    if (this.defaultFilters) {
      var filter = this.defaultFilters;
      this.setUserAuthorityFilter(filter);
      this.getEmployees();
    }
    this.getDepartments();
    this.getAccessGroups();
    if (this.modules.diningHall) {
      this.getFoodGroups();
    }
    this.getReaders();
    this.getStatus();
    this.getStates();
    this.getTitles();
    this.getWorkGroups();
    this.getExtraFields();
    this.getAllowences();
  }
};
</script>
<style scoped>
.dep-baslik>th {
  font-weight: bold;
  background-color: #3c8dbc;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/pages/payrollManagement/PayrollManagement.vue